/* eslint-disable no-console */

import { unregister } from 'register-service-worker';

unregister();
